// === Timeline Component (Pill Tabs) ===

import store from '../state/store.js';
import { getElements } from '../utils/dom.js';
import { SHORT_MONTHS } from '../utils/date.js';

export function setupTimeline() {
  const els = getElements();
  els.monthPills.innerHTML = SHORT_MONTHS.map((m, i) =>
    `<button class="month-pill${i === store.currentMonth ? ' active' : ''}" data-month="${i}">${m}</button>`
  ).join('');
  scrollToActivePill();
}

export function updateTimelinePills() {
  const els = getElements();
  els.monthPills.querySelectorAll('.month-pill').forEach((btn, idx) => {
    btn.classList.toggle('active', idx === store.currentMonth);
  });
  scrollToActivePill();
}

function scrollToActivePill() {
  const els = getElements();
  const active = els.monthPills.querySelector('.month-pill.active');
  if (active) {
    active.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
  }
}
